import { useEffect, useRef, lazy, Suspense } from 'react';

const TextField = lazy(() => import('@mui/material/TextField'));
const MenuItem = lazy(() => import('@mui/material/MenuItem'));
const Autocomplete = lazy(() => import('@mui/material/Autocomplete'));
const Select = lazy(() => import('@mui/material/Select'));
const InputLabel = lazy(() => import('@mui/material/InputLabel'));
const Chip = lazy(() => import('@mui/material/Chip'));

import { inputLabelClasses } from "@mui/material/InputLabel";
import { getModalStyle } from '@/utils/Modal';

import { getColors, getDarkMode } from '@/utils/Settings';

export default function DropdownInput({
    sx,
    id,
    ref,
    column,
    table,
    name,
    t,
    translate,
    value,
    className,
    autoComplete,
    required,
    isFocused,
    onChange,
    inputValue,
    onInputChange,
    options,
    placeholder,
    native,
    error,
    multiple,
    onKeyUp,
    onKeyDown,
    values,
    handleValueDelete,
    norender,
    size,
    shrink,
    disabled,
    noempty
}){

    var itemKey = 'item';
    if(table){
        itemKey = table;
    }

    var itemSubKey = 'subitem';
    if(column){
        itemSubKey = column;
    }


    const {lightColor,darkColor,lightColorGradient,darkColorGradient} = getColors();
    const darkmode = getDarkMode();

    var input = useRef(null);
    if(ref){
        input = ref;
    }
    
    useEffect(() => {
        if(isFocused && input.current){
            //input.current.focus();
        }
    }, [input]);

    var classString = '';
    if(className && className.length !== 0){
        classString = className;
    }

    var inputProperties = {className: classString};

    if(native){
        inputProperties.native = true;   
    }

    //MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary Mui-error MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall MuiInputBase-adornedEnd MuiAutocomplete-inputRoot css-pu6re7-MuiInputBase-root-MuiOutlinedInput-root

    var inputLabelProperties = {
        sx: {
            // set the color of the label when not shrinked
            //color: "red",
            [`&.${inputLabelClasses.shrink}`]: {
                // set the color of the label when shrinked (usually when the TextField is focused)
                color: darkmode ? darkColor : lightColor,
                marginTop: multiple || autoComplete ? 0 : '-13px'
            }
        }
    };

    if(shrink){
        inputLabelProperties.shrink = true;
    }

    /*
    var sx = {        
        "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2e2e2e !important"
        }
    }
    */
    var sxStyle = {
        padding: 0,
        "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-error": {
            backgroundColor: darkmode ? darkColorGradient : lightColorGradient
        },
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
            width: '100%',
            // if not multiple or autoComplete, leave default value (without !important it does not take the property)
            paddingRight: multiple /*|| autoComplete*/ ? '70px !important' : '20px !important'
        },
        /*
        "& .MuiInputBase-root.MuiOutlinedInput-root span": {
            width: '100%'
        }
        */
        "& .MuiInputBase-root.MuiOutlinedInput-root .MuiChip-root": {
            //display: 'block',
            //width: '100%',
            maxWidth: '100%'
        },
        "& .MuiAutocomplete-option": {
            alignItems: "left"
        }
    };

    if(sx){
        sxStyle = {...sx,sxStyle};
    }

    var sizeString = 'small';
    if(size){
        sizeString = size;
    }

    /*
    if(autoComplete){
        sx = {           
           "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                backgroundColor: darkmode ? "rgb(115 115 115)" : "#FFFFFF"
            },
           "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']": {
                backgroundColor: darkmode ? "rgb(115 115 115)" : "#FFFFFF"
              },
           "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true'] .Mui-focused": {
              backgroundColor: darkmode ? "rgb(115 115 115)" : "#FFFFFF"
           }
        };
    }
    */

    /*
    var sxChip = {
        zIndex: 1,
        padding: '0px 2px 0px 0px', 
        margin: '2px'
    };

    if(darkmode){
        sxChip = {
            ...sxChip,
            color: '#FFFFFF',
            '& .MuiChip-deleteIcon' : {
                color: '#FFFFFF'
            }
        };
    }
    else{
        sxChip = {
            ...sxChip,
            //color: '#FF8C00',
            '& .MuiChip-deleteIcon' : {
                color: '#810000'
            }
        };
    }
    */
    const { sxChip } = getModalStyle();

    // autocomplete is for single value with search
    // multiple is for multiple values with search

    // forcing simple select to be autoComplete because with fullscreen it fails

    return (            
        autoComplete ?
            <Suspense>
                <Autocomplete
                    disabled={disabled}
                    sx={sxStyle}
                    size={sizeString}
                    id={id}                
                    name={name}
                    value={value}
                    //inputValue={inputValue}
                    //onInputChange={onInputChange}
                    onChange={onChange}
                    disablePortal
                    clearIcon={null}
                    options={options ?? []}
                    getOptionKey={(option) => option?.id}  // to avoid warnings because same names
                    // if we want to use a field not called 'label'
                    getOptionLabel={
                        (option) => 
                            option?.name ?
                                t && translate ?
                                    t(translate+'.'+option.name)
                                :
                                    option.name
                            : 
                                option?.id ?
                                    option.id.toString()
                                :
                                    ''
                    }
                    renderInput={(params) => // input field where we type
                        <TextField 
                            {...params}   
                            sx={{
                                display: "flex",
                                flexWrap: "wrap"
                            }}
                            label={placeholder}  
                            InputLabelProps={inputLabelProperties}
                            onKeyUp={onKeyUp}
                            onKeyDown={onKeyDown}
                            error={error && error.length > 0 ? true : false}
                            helperText={error && error.length > 0 ? error : ''}                          
                        />
                    }
                    /*
                    renderValue={(option) => (   
                        <div className='ms-1'>
                        {
                            option?.name ?                                         
                                t && translate ?
                                    t(translate+'.'+option.name)
                                :
                                    option.name
                            : 
                                option.id?.toString()                        
                        }
                        </div>
                    )}
                    */                    
                    renderValue={(option, getItemProps) => (

                        option?.id &&                            
                            <Chip                                
                                {...getItemProps()}                         
                                key={itemKey+'_'+itemSubKey+'_'+option.id}
                                //{...getTagProps({ index })}
                                sx={sxChip}                        
                                variant="outlined"
                                //label={value?.name ? value.name : value.id.toString()}
                                label={
                                    option?.name ?                                         
                                        t && translate ?
                                            t(translate+'.'+option.name)
                                        :
                                            option.name
                                    : 
                                        option.id?.toString()
                                }
                                onDelete={(e) => {
                                    handleValueDelete(e,option);
                                }}
                                onClick={() => {}}                                
                            /> 
                    )}
                />
            </Suspense>
            
        :
            multiple ?
                <Suspense>
                    <Autocomplete
                        disabled={disabled}
                        size={sizeString}
                        sx={sxStyle}
                        id={id}                
                        name={name}
                        value={value}
                        values={values}
                        inputValue={inputValue}
                        onInputChange={onInputChange}
                        onChange={onChange}
                        disablePortal
                        options={options ?? []}
                        getOptionLabel={
                            (option) => 
                                option?.name ? 
                                    option.name 
                                : 
                                    option?.id ?
                                        option.id.toString()
                                    :
                                        ''
                        } // if we want to use a field not called 'label'
                        required={required}           
                        InputProps={inputProperties}
                        renderInput={(params) => 
                            <TextField 
                                {...params}  
                                inputRef={ref}
                                label={placeholder}
                                InputLabelProps={inputLabelProperties}
                                error={error && error.length > 0 ? true : false}
                                helperText={error && error.length > 0 ? error : ''}
                                onKeyUp={onKeyUp}
                                onKeyDown={onKeyDown}
                                InputProps={{
                                    ...params.InputProps,
                                    ...inputProperties,
                                    startAdornment: (
                                        !norender && values && values?.map((item) => (                                
                                            item?.id &&
                                            <span key={itemKey+'_'+itemSubKey+'_'+item?.id}>
                                                <Suspense>
                                                <Chip                                            
                                                    sx={sxChip}
                                                    label={item?.name ? item.name : item.id.toString()}                                                
                                                    variant="outlined"
                                                    onDelete={(e) => {
                                                        handleValueDelete(e,item);
                                                    }}
                                                    onClick={() => {}}
                                                />     
                                                </Suspense>                           
                                            </span>
                                        ))
                                                                            
                                    )/*,
                                    endAdornment: (
                                        <React.Fragment>
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    )*/
                                }}
                            />
                        }
                    />       
                </Suspense>         
            :
                <Suspense>
                    {
                        shrink &&
                        <InputLabel
                            color={darkmode ? "#FFFFFF" : "#810000"}
                            shrink={inputLabelProperties.shrink} 
                            sx={inputLabelProperties.sx}  
                            variant={inputLabelProperties.shrink ? 'filled' : ''}
                        >
                            {placeholder}
                        </InputLabel>
                    }
                    <Select
                        disabled={disabled}
                        size={sizeString}
                        sx={sxStyle}
                        id={id}                        
                        inputRef={input}
                        name={name}                    
                        value={options ? value === null ? '' : value : ''}
                        onChange={onChange}                        
                        error={error && error.length > 0 ? true : false}  
                        helperText={error && error.length > 0 ? error : ''}                  
                        fullWidth                        
                    >
                        {
                            !noempty &&
                            <MenuItem 
                                key={itemKey+'_'+itemSubKey+'_0'}
                                value={null}
                            >
                                {!shrink && placeholder && placeholder?.length > 0 ? placeholder : '---'}
                            </MenuItem>
                        }
                        {
                            options && options?.map((item) => (                                
                                <MenuItem 
                                    key={itemKey+'_'+itemSubKey+'_'+item?.id}
                                    value={item?.id}
                                >
                                    {
                                        t && translate ?
                                            t(translate+'.'+item?.name)
                                        :
                                            item?.name
                                    }
                                </MenuItem>                                
                            ))
                        }
                    </Select>
                </Suspense>
    );
}